const proposalSendType = {
    SEND_QUOTE_LEGACY : 'Send Quote Legacy',

    SEND_PROPOSAL : 'Send Proposal'

};

angular.module('gw-um-j2js')
    .constant('proposalSendType', proposalSendType);